import Vue from 'vue'

Vue.component('PeopleCard', {
  template: '#people-card',
  props: ['name', 'url', 'image', 'email', 'title', 'cities']
})